import * as React from "react";
import styles = require("./empty.less");
import * as cn from "classnames";

interface PanelProps {
    description: React.ReactNode;
    imageSrc: string;
    imageWidth: number;
    imageHeight: number; // Needed to ensure image dimensions are set on page load (to stop the content jumping around as images load).
    imageAlt: string;
    className?: any;
}

const Panel = (props: PanelProps) => {
    return <div className={cn(styles.panel, props.className)}>
        <div className={styles.header}>
            <img src={props.imageSrc} alt={props.imageAlt} width={props.imageWidth} height={props.imageHeight} />
        </div>
        <div className={styles.body}>
            {props.description}
        </div>
    </div>;
};

export default Panel;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/GettingStarted/Panel.tsx